import { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { Alert, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Input from '../../components/Form/Input';
import ResetPasswordButton from './components/ResetPasswordButton';
import { Text } from '../../components';
import authService from '../../services/napoleon/AuthService';
import { ContainerMain, FormContainer, styles } from './styles';

export default function ResetPasswordMUI() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const { token } = queryString.parse(location.search);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!token) {
      setMessage('Token inválido.');
      return;
    }

    if (password.length < 6) {
      setMessage('A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      setMessage('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    try {
      const res = await authService.resetPassword(token, password);
      setMessage(res.data?.message || 'Senha atualizada com sucesso! Redirecionando para login...');
      setPassword('');
      setConfirmPassword('');

      setTimeout(() => history.push('/login'), 3000);
    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContainerMain>
      <FormContainer onSubmit={handleSubmit}>
        <Text sx={styles.title}>Redefinir senha</Text>

        {message && (
          <Alert severity={message.includes('sucesso') ? 'success' : 'error'} sx={styles.alert}>
            {message}
          </Alert>
        )}

        <Input
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Nova senha"
          fullWidth
          sx={styles.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Input
          type={showConfirmPassword ? 'text' : 'password'}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirmar senha"
          fullWidth
          sx={styles.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword((prev) => !prev)} edge="end">
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <ResetPasswordButton
          type="submit"
          variant="contained"
          color="primary"
          loading={loading}
          disabled={loading}
          sx={styles.button}
        >
          {loading ? 'Alterando...' : 'Alterar senha'}
        </ResetPasswordButton>
      </FormContainer>
    </ContainerMain>
  );
}
